<div class="col-12 p-0" *ngIf="loaded">
  <ng-container *ngIf="classifiedComunications && classifiedComunications.length > 0; else noCommunications">
    <!-- TABLA DE COMUNICACIONES -->
    <div class="col-12">
      <!-- FILTROS HIDDEN
      <div class="filterHeader m-t-sm m-b-sm">HIDDENS <div class="col-12">
          <ng-container *ngFor="let key of hiddenActiveFilters.keys()">
            <span>
              <a class="btn btn-filter btn-xs m-xs"> {{ key }} <span>= {{ hiddenActiveFilters.getAll(key)[0] }}</span>
                <i class="fas fa-times ml-1" aria-hidden="true"></i>
              </a>
            </span>
          </ng-container>
        </div>
      </div>-->
      <!-- FILTROS -->
      <div class="filterHeader m-t-sm m-b-sm" *ngIf="activeFilters.length> 1 ">
        <div class="col-12">
          <ng-container *ngFor="let filter of activeFilters">
            <span (click)="removeFilter(filter)" *ngIf="filter.key!='projectId'&&filter.value!=undefined">
              <a class="btn btn-filter btn-xs m-xs"> {{ filter.label }} <span *ngIf="filter.value !== true">= {{
                  filter.value&&filter.value.identifier? filter.value.identifier:filter.value}}</span>
                <i class="fas fa-times ml-1" aria-hidden="true"></i>
              </a>
            </span>
          </ng-container>
        </div>
      </div>
      <p-tabView (onChange)="handleChangeTab($event)" class="m-t-sm d-block">
        <p-tabPanel *ngFor="
            let communicationsChannel of classifiedComunications;
            let i = index
          " [selected]="i === selectedTab">
          <ng-template pTemplate="header">{{ communicationsChannel.channel.description }}&nbsp;<span aria-hidden="true"
              class="badge badge-warning">{{ getNumberOfCommunications(communicationsChannel.communications) }}</span>
          </ng-template>
          <ng-container [ngTemplateOutlet]="communicationsList" [ngTemplateOutletContext]="{
              title: 'Canal',
              communications: communicationsChannel.communications
            }">
          </ng-container>
        </p-tabPanel>
      </p-tabView>
    </div>
  </ng-container>
  <!-- TEMPLATE CON LA TABLA QUE REPRESENTA UN LISTADO DE COMUNICACIONES -->
  <ng-template #communicationsList let-communications="communications">
    <div class="col-12">
      <p-table [value]="communications" [responsive]="true" sortField="sortField" sortOrder="-1" dataKey="identifier"
        [expandedRowKeys]="expandedRows" [paginator]="communications && communications.length > 20" [pageLinks]="4"
        [rowsPerPageOptions]="[15, 30, 100]" (onPage)="this.savePages($event)" [rows]="20"
        [first]="this.ptableConf.first" [rows]="this.ptableConf.rows">
        <ng-template pTemplate="header">
          <tr>
            <th [style.width]="'5%'"></th>
            <th [style.width]="'30%'">{{ colHeaders[1] | translate }}</th>
            <th [style.width]="'25%'">{{ colHeaders[2] | translate }}</th>
            <th [style.width]="'5%'" class="text-center">{{ colHeaders[3] | translate }}</th>
            <th [style.width]="'15%'" class="text-center">{{ colHeaders[4] | translate }}</th>
            <th [style.width]="'15%'">{{ colHeaders[5] | translate }}</th>
            <th [style.width]="'5%'" class="text-center"></th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-expanded="expanded" let-communication>
          <tr>
            <td [style.width]="'5%'">
              <a href="#" [pRowToggler]="communication" *ngIf="communication.responses?.length > 0">
                <i [ngClass]="
                  expanded ? 'fas fa-lg fa-chevron-down' : 'fas fa-lg fa-chevron-right'
                "></i>
              </a>
            </td>
            <td [style.width]="'30%'">
              <span class="p-column-title">{{ colHeaders[1] | translate }}</span>
              <a role="link" (click)="viewDetail(communication)">
                <span class="commSubject"><i *ngIf="communication?.repliedCommunication?.communicationUUID"
                    class="fas fa-reply" aria-hidden="true"></i> {{ communication.subject }} </span>
                <div class="commBody">{{ communication.activity?.description }} </div>
              </a>
            </td>
            <td [style.width]="'25%'">
              <span class="p-column-title">{{ colHeaders[2] | translate }}</span> {{
              getAgentListDescription(communication)}}
            </td>
            <td class="text-center" [style.width]="'5%'">
              <span class="p-column-title ">{{ colHeaders[3] | translate }}</span>
              <ng-container *ngIf="communication.errors && communication.errors.length > 0">
                <a (click)="showErrors(communication)" #actualTarget>
                  <i class="fa fa-1-5x" [ngClass]="getStatusIcon(communication.status)"
                    [pTooltip]="getStatusTooltip(communication.status)" tooltipPosition="right"
                    [escape]="false"></i></a>
              </ng-container>
              <ng-container *ngIf="!communication.errors || communication.errors.length === 0">
                <i class="fa fa-1-5x" [ngClass]="getStatusIcon(communication.status)"
                  [pTooltip]="getStatusTooltip(communication.status)" tooltipPosition="right"></i>
              </ng-container>
            </td>
            <td class="text-center" [style.width]="'15%'">
              <span class="p-column-title">{{ colHeaders[4] | translate }}</span> {{ getCommunicationDate(communication)
              | date: 'dd/MM/yyyy HH:mm:ss' }}
            </td>
            <td [style.width]="'15%'">
              <span class="p-column-title">{{ colHeaders[5] | translate }}</span>
              <span class="registrerNum">{{ communication.registerInfo?.registerNumber }}</span>
              <div class="registerDate">
                <ng-container *ngIf="communication.registerInfo?.date"> {{communication.registerInfo.date |
                  date:'dd/MM/yyyy HH:mm:ss'}}</ng-container>
              </div>
            </td>
            <td [style.width]="'5%'">
              <span class="p-column-title">{{ colHeaders[6] | translate }}</span>
              <communication-actions [communication]="communication" (deleted)="deleteFromList(communication)"
                [editable]="this.isChannelEditable(communication.channel)&&this.isPerfilValido()"
                [permitecopia]="this.isChannelPermiteCopia(communication.channel)"
                (commDetailWindow)="this.onCommDetailWindow()">
              </communication-actions>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="rowexpansion" let-communication>
          <tr>
            <td colspan="7">
              <ng-container *ngTemplateOutlet="commResponses;context:{responses: communication.responses}">
              </ng-container>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="7" class="text-center">{{ 'General.noData' | translate }}</td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </ng-template>
  <!-- TEMPLATE SI NO HAY COMUNICACIONES -->
  <ng-template #noCommunications>
    <div class="col-12">
      <div class="widget style1 bg-info">
        <div class="row">
          <div class="col-4">
            <i class="fas fa-info fa-3x"></i>
          </div>
          <div class="col-8 text-right">
            <h2 class="font-bold">
              <div>{{ 'Communications.noData' | translate}}</div>
            </h2>
          </div>
        </div>
      </div>
    </div>
  </ng-template>
  <!-- TABLA DE RESPUESTAS-->
  <ng-template #commResponses let-responses="responses">
    <div class="col-12 p-0">
      <p-table [value]="responses" [responsive]="true" [rows]="20" sortField="sortField" sortOrder="-1"
        [ngClass]="'responseComm'">
        <ng-template pTemplate="body" let-communication>
          <tr>
            <td [style.width]="'35%'"></td>
            <td [style.width]="'25%'">
              <span class="p-column-title">{{ 'Communications.table.from' | translate }}</span>
              <i class="fas fa-reply" aria-hidden="true"></i> {{ getAgentListDescription(communication)}}
            </td>
            <td [style.width]="'5%'" class="text-center">
              <span class="p-column-title">{{ colHeaders[3] | translate }}</span>
              <ng-container *ngIf="communication.errors && communication.errors.length > 0">
                <a (click)="showErrors(communication)" #actualTarget>
                  <i class="fa fa-1-5x" [ngClass]="getStatusIcon(communication.status)"
                    [pTooltip]="getStatusTooltip(communication.status)" tooltipPosition="right"
                    [escape]="false"></i></a>
              </ng-container>
              <ng-container *ngIf="!communication.errors || communication.errors.length === 0">
                <i class="fa fa-1-5x" [ngClass]="getStatusIcon(communication.status)"
                  [pTooltip]="getStatusTooltip(communication.status)" tooltipPosition="right"></i>
              </ng-container>
            </td>
            <td [style.width]="'15%'" class="text-center">
              <span class="p-column-title">{{ colHeaders[4] | translate }}</span> {{ getCommunicationDate(communication)
              | date: 'dd/MM/yyyy HH:mm:ss' }}
            </td>
            <td [style.width]="'15%'">
              <span class="p-column-title">{{ colHeaders[5] | translate }}</span>
              <span class="registrerNum">{{ communication.registerInfo?.registerNumber }}</span>
              <div class="registerDate">
                <ng-container *ngIf="communication.registerInfo?.date"> {{communication.registerInfo.date |
                  date:'dd/MM/yyyy HH:mm:ss'}}</ng-container>
              </div>
            </td>
            <td [style.width]="'5%'">
              <span class="p-column-title">{{ colHeaders[6] | translate }}</span>
              <communication-actions [communication]="communication" (deleted)="deleteFromList(communication)"
                [editable]="false">
              </communication-actions>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="rowexpansion" let-communication>
          <tr>
            <td colspan="7">
              <ng-container *ngTemplateOutlet="commResponses;context:{responses: communication.responses}">
              </ng-container>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="7" class="text-center">{{ 'General.noData' | translate }}</td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </ng-template>
</div>
<!--Dialogo de selección de actividad -->
<p-dialog [resizable]="true" header="{{ 'Communications.activitySelection.title' | translate }}"
  [(visible)]="activitySelectionVisible" [closable]="true" [responsive]="true" [dismissableMask]="true"
  [closeOnEscape]="true" [modal]="true" [appendTo]="'body'" [style]="{'width':'60vw'}">
  <p-scrollPanel [style]="{width: '100%', height: '80vh'}" styleClass="custombar1">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12 alert alert-info"> {{ 'Communications.activitySelection.msg.selection' | translate}} </div>
        <div class="col-12">
          <p-listbox [options]="activities" filter="true" dataKey="identifier" [(ngModel)]="activitySelection"
            styleClass="w-100 dialog80">
          </p-listbox>
        </div>
        <div class="col-12 d-flex justify-content-end m-t-md m-b-md">
          <button class="btn btn-sm btn-secondary" (click)="newCommunication()" appNoDblClick>
            <i class="fas fa-check"></i> {{'General.accept' | translate}} </button>
        </div>
      </div>
    </div>
  </p-scrollPanel>
</p-dialog>
<!--
    *************************************************************************************************
    ZONA DE FILTROS AVANZADOS (MODAL)
    *************************************************************************************************
  -->
<p-dialog header="{{ 'General.filters' | translate }}" [(visible)]="filtersVisible" [responsive]="true"
  (onHide)="onCloseFilters()" [modal]="true" [resizable]="false" [closable]="true" [closeOnEscape]="false"
  [blockScroll]="true" [style]="{'width':'60vw'}" [contentStyle]="{ 'max-height': '80vh', overflow: 'hidden'}"
  styleClass='searchStyle'>
  <sub-header [isModal]="true" [windowHash]=this.filterWindowHash [includeContextHelp]="false" *ngIf="filtersVisible">
  </sub-header>
  <p-scrollPanel [style]="{width: '100%', height: '80vh'}" styleClass="custombar1">
    <div class="container-fluid pb-5">
      <div class="row">
        <div class="col-12">
          <formPlyca #formPlycaRef1 [formConfig]="formConfigFilters" *ngIf="formConfigFilters"
            [manageWaitService]=false>
          </formPlyca>
        </div>
      </div>
    </div>
  </p-scrollPanel>
</p-dialog>